import Navigation from "@/components/landing/Navigation";
import Hero from "@/components/landing/Hero";
import BioLogos from "@/components/landing/BioLogos";
import FeaturedWorks from "@/components/landing/FeaturedWorks";
import Services from "@/components/landing/Services";
import Speaking from "@/components/landing/Speaking";
import Testimonials from "@/components/landing/Testimonials";
import PersonalInterests from "@/components/landing/PersonalInterests";
import FooterCTA from "@/components/landing/FooterCTA";
import FloatingBookCall from "@/components/landing/FloatingBookCall";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="relative w-full overflow-x-hidden bg-white">
      <Navigation />
      <Hero />
      <BioLogos />
      <FeaturedWorks />
      <Services />
      <Speaking />
      <Testimonials />
      <PersonalInterests />
      <FooterCTA />
      <FloatingBookCall />
    </main>
  );
}
